// ==========================================
// SCRIPT LOADER - Avone OS (Optimizado)
// ==========================================

var domain_url = window.location.hostname;
var domain_admin_url = Shopify.shop;
var current_url = window.location.href;

// Verificación de licencia del tema (Mantenido original)
if (current_url.indexOf(domain_url) < 0 && current_url.indexOf(domain_admin_url) < 0 && current_url.indexOf("shopifypreview.com") < 0 && current_url.indexOf("shopify.com") < 0) {
    console.log("Unauthorised use of code detected.");
} else {
    var script_loaded = false;

    function loadAsync() {
        if (script_loaded) return;
        script_loaded = true;

        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; i++) {
            
            // 1. Convertir data-src en src (Activar scripts de Apps)
            if (scripts[i].getAttribute("data-src") !== null) {
                scripts[i].setAttribute("src", scripts[i].getAttribute("data-src"));
                delete scripts[i].dataset.src;
            }
            
            // 2. Corregir error de Shopify que inyecta type="text/javascripts" (con 's' de más)
            if (scripts[i].getAttribute("type") === "text/javascripts") {
                var newScript = document.createElement("script");
                for (var j = 0; j < scripts[i].attributes.length; j++) {
                    var attr = scripts[i].attributes[j];
                    newScript.setAttribute(attr.name, attr.value);
                }
                newScript.type = "text/javascript";
                newScript.innerHTML = scripts[i].innerHTML;
                scripts[i].parentNode.removeChild(scripts[i]);
                scripts[i].parentNode.insertBefore(newScript, scripts[i]);
            }
        }

        // Disparar eventos personalizados para que las Apps sepan que ya pueden iniciar
        setTimeout(function(){ document.dispatchEvent(new CustomEvent("StartAsyncLoading")); }, 900);
        document.dispatchEvent(new CustomEvent("startasyncloading"));
    }

    // 🛠️ CAMBIO 1: Removido "mousemove". Solo se activa con scroll, toque o clic.
    // 🛠️ CAMBIO 2: Agregado "{ once: true, passive: true }". 
    // Esto significa que el evento se destruye automáticamente después de ejecutarse una sola vez (ahorra RAM).
    window.addEventListener("scroll", loadAsync, { once: true, passive: true });
    window.addEventListener("touchstart", loadAsync, { once: true, passive: true });
    window.addEventListener("mousedown", loadAsync, { once: true, passive: true });

    // 🛠️ CAMBIO 3: Reducido el tiempo límite de 9 segundos (9000ms) a 4 segundos (4000ms).
    // A los 4 segundos ya se han cargado las fuentes y el CSS, es el momento perfecto para activar el píxel y las apps sin penalizar PageSpeed.
    if (window.addEventListener) {
        window.addEventListener("load", function(){ setTimeout(loadAsync, 4000); }, false);
    } else if (window.attachEvent) {
        window.attachEvent("onload", function(){ setTimeout(loadAsync, 4000); });
    } else {
        window.onload = loadAsync;
    }
}